export default __webpack_public_path__ + "static/media/icon-192x192.53f24e11.png";